function RemoveTopic() {
}

module.exports = RemoveTopic;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/remove-topic/remove-topic.js
// module id = 334
// module chunks = 1